export default __webpack_public_path__ + "static/media/h22koritu.fd17822b.mp3";